module.exports = __webpack_public_path__ + "img/part3-3.4d702634.png";